/*
 * BrandStencil stats
 *
 * Load stats from the BrandStencil application
 */

import { CountUp } from 'countup.js';
import calculateROI from '../utils/calculate-roi';

class BrandStencilStats {
  constructor() {
    const API_URL =
      'https://app.brandstencil.com/system-api/get-data/Ci0ywOXEpFtUnrbnIBujiaBeVg4ViQcs';
    const POST_DATA =
      'data=getUserCount,getResourceCount,getTemplateCount,getMonthCount';
    const DEFAULT_STATS = {
      resourceCount: 84089,
      userCount: 8461,
      templateCount: 459,
    };
    const brandStencilStats = document.querySelectorAll('[data-bs-stat]');

    if (brandStencilStats.length > 0) {
      const request = new XMLHttpRequest();
      request.open('POST', API_URL, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded'
      );
      request.setRequestHeader(
        'Accept',
        'application/vnd.brandstencil.v1+json'
      );

      request.send(POST_DATA);

      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const response = JSON.parse(request.responseText);

          if ('data' in response) {
            // Tidy up the API response
            this.showStats({
              resourceCount: parseInt(response.data.getResourceCount),
              userCount: parseInt(response.data.getUserCount),
              templateCount: parseInt(response.data.getTemplateCount),
              saving: calculateROI(
                response.data.getResourceCount,
                response.data.getTemplateCount,
                response.data.getMonthCount
              )[0],
            });
          }
        } else {
          // We reached our target server, but it returned an error
          console.log(JSON.parse(request.responseText));
          // Use some default values
          this.showStats(DEFAULT_STATS);
        }
      };
    }
  }

  showStats(stats) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(
      this.onStatVisible,
      observerOptions
    );

    // Loop through stats
    for (const [stat, value] of Object.entries(stats)) {
      // Find the matching elements
      const targetElements = document.querySelectorAll(
        `[data-bs-stat=${stat}]`
      );
      if (targetElements.length > 0) {
        // We convert this to an Array because IE11 doesn't support iterating through a
        // NodeList using .forEach()
        [...targetElements].forEach((targetElement) => {
          // Add the target value as a data attribute
          targetElement.setAttribute('data-countup-value', value);
          // Observe this element
          observer.observe(targetElement);
        });
      }
    }
  }

  onStatVisible(changes, observer) {
    changes.forEach((change) => {
      if (change.intersectionRatio > 0) {
        const target = change.target;
        const countUp = new CountUp(
          target,
          target.getAttribute('data-countup-value')
        );
        countUp.start();
        observer.unobserve(target);
      }
    });
  }
}

export default BrandStencilStats;
